<template>
  <div class="stat-section" v-if="items.length > 0">
    <ion-list class="mt-20 mb-2 ladder-wrapper" lines="none">
      <ion-item class="header-row">
        <ion-label class="ion-text-wrap" v-for="(header) in headers">
          <ion-text >
            <span class="stats-header ">
              {{ header }}
            </span>
          </ion-text>
        </ion-label>
      </ion-item>
      <div class="team-wrapper" v-for="(item) in items" :key="item._id">
        <ion-item>
          <ion-label class="ion-text-wrap player-name" v-for="(data) in item">
            <ion-text>
              <img class="club-logo" v-if="data.type == 'image'" :src="get(player, 'teamImg.imgUrl', clubPlaceholder)"/>
              <span class="stats" v-else style="font-weight:600">
                {{ data.value }}
              </span>
            </ion-text>
          </ion-label>
        </ion-item>
      </div>
    </ion-list>
  </div>
  <div class="option-row d-flex justify-center mt-20" v-else>
    <p class="c-white">
      {{ noDataMsg ? noDataMsg : 'No data' }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'TableList',
  props: {
    headers: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    noDataMsg: {
      type: String,
      required: false,
      default: 'No data',
    }
  },
  data() {
    return {
      key: 0,
      get: _.get,
    }
  },
  methods: {
  },
  computed: {
    clubPlaceholder() {
      return process.env.VUE_APP_PLACEHOLDER;
    },
  }
};
</script>

<style scoped lang="scss">

/* Assemble Sports Fonts */
@font-face {
  font-family: 'BrownStd-Bold';
  src: url('../assets/fonts/BrownStd-Bold.otf') format('truetype'); /* IE9 Compat Modes */
}
@font-face {
  font-family: 'BrownStd-Regular';
  src: url('../assets/fonts/BrownStd-Regular.otf') format('truetype'); /* IE9 Compat Modes */
}
@font-face {
  font-family: 'BrownStd-Light';
  src: url('../assets/fonts/BrownStd-Light.otf') format('truetype'); /* IE9 Compat Modes */
}

.fade-enter-active,
.fade-leave-active {
  transition: all .5s;
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active below version 2.1.8 */

{
  opacity: 0;
  height: 0;
}

.team-name {
  min-width: 10rem;
  @media only screen and(min-width: 350px) {
    min-width: 3rem;
    .team-name-text {
      display:none;
    }
  }
}

.player-name {
  min-width: 10rem;
  @media only screen and(min-width: 350px) {
    min-width: 7rem;
  }
}
.stat-col {
  min-width: 3rem;
  max-width: 3rem;
}
.rank-col {
  min-width: 3rem;
  max-width: 3rem;
  @media only screen and(min-width: 350px) {
    min-width: 2.5rem;
  }
}

.ladder-wrapper {
  border-radius: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  padding-bottom: 1.5rem;
  /* box-shadow:
  0 0.4px 0.4px rgba(0, 0, 0, 0.016),
  0 1px 1px rgba(0, 0, 0, 0.022),
  0 2.1px 2.1px rgba(0, 0, 0, 0.028),
  0 4.4px 4.4px rgba(0, 0, 0, 0.034),
  0 12px 12px rgba(0, 0, 0, 0.05)
; */
  -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
}

.stats {
  font-family: 'BrownStd-Regular';
  display:flex;
  font-style: normal;
  font-weight: normal;
  font-size: 0.7rem;
  line-height: 1rem;
  /* identical to box height, or 123% */

  text-align: center;

  color: white;
  .club-logo{
    width: 1.25rem;
  height: 1.25rem;
  border: 2px solid rgba(226, 9, 9, 0.1);
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  transition: all 0.1s ease-in-out;
  margin-right:0.5rem;
  }
  text-overflow: clip;
}

.option-row {
  --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  background: $background !important;
}

.stats-pts {
  font-family: 'BrownStd-Bold';
  font-weight: bold;
}

.pool-name {
  font-family: "BrownStd-Regular";
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white;
}

.stats-header {
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: .8rem;
  line-height: 1rem;
  /* identical to box height, or 114% */

  text-align: center;

  color: white;
  text-overflow: clip;
}

.active {
  background: $highlight;
}

ion-list, ion-item {
  background: transparent;
  --background: transparent;
}



</style>
